import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { describeWhen } from '@/lib/plans';
import { useDocumentsStore } from '@/stores/documentsStore';

const STATUS_TEXT = { decomposing: 'reading', asking: 'your turn', planning: 'planning', planned: 'planned', failed: 'stopped' } as const;

/** The documents not planned yet, each a click back to its questions. */
export function RecentDocuments() {
  const navigate = useNavigate();
  const recent = useDocumentsStore((s) => s.recent);
  const loadRecent = useDocumentsStore((s) => s.loadRecent);

  useEffect(() => {
    void loadRecent();
  }, [loadRecent]);

  const open = recent.filter((d) => d.status !== 'planned');
  if (open.length === 0) return null;
  return (
    <div className="rounded-xl border border-border bg-card">
      <div className="border-b border-border/60 px-4 py-2 text-xs font-medium text-muted-foreground">Documents in progress</div>
      <ul className="divide-y divide-border/60">
        {open.map((d) => (
          <li key={d.id}>
            <button onClick={() => navigate(`/changes/documents/${d.id}`)} className="flex w-full items-center gap-3 px-4 py-2.5 text-left hover:bg-secondary/40">
              <FileText className="h-4 w-4 shrink-0 text-muted-foreground" />
              <span className="min-w-0 flex-1 truncate text-sm text-foreground">{d.filename}</span>
              <span className="text-xs text-muted-foreground">{STATUS_TEXT[d.status]} · round {d.round}</span>
              <span className="shrink-0 text-xs text-muted-foreground">{describeWhen(d.updated_at)}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
